import { Checkbox, PrimaryButton, SPACING } from '@monthio/design-system'
import config from '#config'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import styled from 'styled-components'

import type { RootState } from '../../store/reducers'

import { flowOrchestrationService } from '../../services/flowOrchestrationService/flowOrchestrationService'
import { deleteSmartCheckSession } from '../../store/actions/smartCheckSessionDeletionActions'
import { SmartCheckSessionsStatus } from '../../store/reducers/smartCheckSessionDeletionReducer'

export const DeleteDataActionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SPACING.s};
	margin-bottom: ${SPACING.m};
`

export const DeleteDataContent = ({
	handleCloseMenu,
}: {
	handleCloseMenu: () => void
}) => {
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const [policyConfirmed, setPolicyConfirmed] = useState(false)

	const handleOnClick = useCallback(() => {
		dispatch(deleteSmartCheckSession())
	}, [])

	const history = useHistory()
	const status = useSelector((state: RootState) => state.deletion.status)
	useEffect(() => {
		if (status === SmartCheckSessionsStatus.LOADING_STATUS) {
			handleCloseMenu()
			history.replace(config.routeCodes.flowDeleted)
			flowOrchestrationService.deleteSession()
		}
	}, [status])

	return (
		<DeleteDataActionsContainer>
			<Checkbox onChange={setPolicyConfirmed}>
				{t('gdprPolicy-confirmation')}
			</Checkbox>
			<PrimaryButton
				disabled={!policyConfirmed}
				onClick={handleOnClick}
				size="xl"
			>
				{t('gdprPolicy-deleteButton')}
			</PrimaryButton>
		</DeleteDataActionsContainer>
	)
}
